import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const NoMessagesIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="138" height="120" viewBox="0 0 138 120" fill="none">
      <path
        opacity="0.3"
        d="M4.99559 44.9679C4.99559 44.9679 -19.1218 105.932 44.3638 106.786C107.849 107.64 136.877 98.2815 137.164 67.2761C137.451 36.2708 114.585 7.29523 74.7318 6.97421C34.879 6.6532 13.3281 18.3185 4.99559 44.9679Z"
        fill="#E7E7E7"
      />
      <path d="M93.9102 20.4081L56.4746 12.7969L44.9928 69.2943L82.4284 76.9055L93.9102 20.4081Z" fill="#CFCFCF" />
      <path d="M94.6462 16.785L57.2107 9.17383L45.7289 65.6713L83.1645 73.2825L94.6462 16.785Z" fill="#E7E7E7" />
      <path d="M90.9814 20.4517L59.1624 13.9824L50.8692 54.7899L82.6882 61.2592L90.9814 20.4517Z" fill="white" />
      <path
        d="M49.6319 42.2998C49.6319 42.2998 40.2658 45.3813 42.6197 51.104C43.8956 54.2053 48.1978 55.4864 51.877 56.0057C52.5658 56.1019 53.2678 56.0045 53.9045 55.7244C54.5411 55.4444 55.0873 54.9927 55.4819 54.4198C55.8766 53.847 56.1041 53.1757 56.139 52.4809C56.174 51.7861 56.015 51.0953 55.6798 50.4858C54.7427 48.695 53.4264 47.1303 51.8226 45.9006L49.6319 42.2998Z"
        fill="#F4A28C"
      />
      <path d="M74.2971 116.904V88.6164L102.578 86.0889L107.632 120L74.2971 116.904Z" fill="#111111" />
      <path
        d="M69.0444 74.193L76.0665 84.0854V88.4726L100.792 86.2617L99.541 74.2078C99.541 74.2078 102.567 59.8638 98.7795 50.4908C97.0971 46.1523 96.3538 41.5061 96.5987 36.8591C96.7817 32.5806 90.6645 31.6013 89.5371 35.7413C89.0722 37.4922 88.7508 41.0535 88.7854 44.6444C88.7986 46.1571 88.4813 47.6544 87.8557 49.0317C86.3722 52.3704 83.8205 58.9241 85.3337 62.5941L82.4408 76.9233L69.0444 74.193Z"
        fill="#F4A28C"
      />
      <path d="M77.4718 6.91016H24.9397V46.267H77.4718V6.91016Z" fill="#106048" />
      <path
        opacity="0.42"
        d="M65.9193 66.4967C67.5307 66.4967 68.837 65.1901 68.837 63.5784C68.837 61.9667 67.5307 60.6602 65.9193 60.6602C64.308 60.6602 63.0017 61.9667 63.0017 63.5784C63.0017 65.1901 64.308 66.4967 65.9193 66.4967Z"
        fill="white"
      />
      <path
        d="M75.9327 14.6605C79.9802 14.6605 83.2614 11.3786 83.2614 7.33026C83.2614 3.28187 79.9802 0 75.9327 0C71.8852 0 68.604 3.28187 68.604 7.33026C68.604 11.3786 71.8852 14.6605 75.9327 14.6605Z"
        fill="#A0A0A0"
      />
      <path
        d="M74.3206 4.24414C74.794 3.87632 75.3835 3.69032 75.9822 3.71984C76.3959 3.70846 76.8068 3.79134 77.1838 3.96221C77.4877 4.10552 77.7431 4.33443 77.9188 4.62086C78.0945 4.90729 78.1828 5.23878 78.1728 5.57466C78.1851 5.94102 78.0755 6.3011 77.8613 6.59853C77.6864 6.86474 77.432 7.06898 77.1344 7.18218C77.4841 7.29084 77.786 7.51602 77.9899 7.82024C78.2099 8.1558 78.3188 8.55203 78.3014 8.95292C78.3069 9.31305 78.2165 9.66815 78.0393 9.98172C77.856 10.2908 77.5837 10.5373 77.258 10.689C76.7732 10.8994 76.2429 10.983 75.717 10.932C75.191 10.8809 74.6866 10.6969 74.2514 10.3972C74.0197 10.1977 73.8356 9.94891 73.7124 9.66908C73.5892 9.38925 73.53 9.08542 73.5393 8.7798H74.8497C74.8484 8.92127 74.8763 9.06149 74.9316 9.1917C74.9869 9.32191 75.0684 9.43931 75.1712 9.53657C75.4011 9.73458 75.699 9.83565 76.0019 9.8185C76.1401 9.82867 76.2788 9.80971 76.4091 9.76285C76.5395 9.71599 76.6585 9.64226 76.7585 9.54646C76.9377 9.35535 77.0337 9.10099 77.0256 8.83915C77.0403 8.68166 77.0144 8.52303 76.9503 8.37841C76.8862 8.2338 76.7862 8.10804 76.6596 8.01314C76.3131 7.82012 75.9178 7.73245 75.5223 7.76088H75.2453V6.65294H75.5173C76.4272 6.65294 76.8822 6.35122 76.8822 5.73789C76.8893 5.61969 76.8714 5.50131 76.8297 5.3905C76.7879 5.27969 76.7232 5.17895 76.6399 5.09488C76.4434 4.92824 76.1897 4.84484 75.9327 4.86241C75.8058 4.85458 75.6787 4.87245 75.5589 4.91494C75.4391 4.95744 75.329 5.02369 75.2354 5.10972C75.0696 5.27532 74.968 5.49443 74.9486 5.728H73.6332C73.6335 5.44562 73.6951 5.16667 73.8138 4.91046C73.9324 4.65425 74.1054 4.4269 74.3206 4.24414Z"
        fill="white"
      />
      <path d="M67.1603 15.2842H35.2593V37.092H67.1603V15.2842Z" fill="white" />
      <path d="M35.2593 15.2842L51.2073 28.2585L67.1603 15.2842H35.2593Z" fill="#A0A0A0" />
      <path
        opacity="0.09"
        d="M42.2685 49.7198H72.4042V46.2568H43.3763C43.3763 46.2568 42.0015 47.8201 42.2685 49.7198Z"
        fill="#111111"
      />
      <path
        opacity="0.09"
        d="M82.421 76.9138L84.9232 87.6668L76.0665 88.4582V84.0709L69.0444 74.1934L82.421 76.9138Z"
        fill="#111111"
      />
    </SvgIcon>
  );
};

export const SendButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path
        d="M13.7133 0.600916L1.77067 4.94683C1.48824 5.04887 1.25596 5.25602 1.12213 5.52503C0.988398 5.79415 0.963435 6.10441 1.05247 6.39138C1.1415 6.67834 1.33776 6.91998 1.60035 7.0659L6.63608 9.86367L9.43263 14.8982C9.53272 15.0816 9.68072 15.2344 9.8608 15.3404C10.0408 15.4463 10.2462 15.5015 10.455 15.5H10.5454C10.7691 15.4834 10.9831 15.4023 11.1616 15.2664C11.34 15.1306 11.4753 14.9458 11.5508 14.7346L15.8948 2.78338C16.042 2.37525 16.0281 1.92632 15.8559 1.52817C15.6837 1.12989 15.3663 0.812361 14.9682 0.640046C14.5702 0.467848 14.1215 0.453932 13.7135 0.60116L13.7133 0.600916ZM14.5347 1.96485C14.6285 2.05654 14.6592 2.19496 14.6131 2.3177L10.4157 13.8615L7.98896 9.48001L11.3683 6.09248C11.5265 5.9179 11.5834 5.67399 11.5187 5.44734C11.454 5.22079 11.2769 5.04358 11.0505 4.97889C10.8239 4.9142 10.5801 4.97104 10.4056 5.12933L7.01953 8.51016L2.63989 6.08235L14.1803 1.88318C14.3038 1.83573 14.4436 1.86736 14.5347 1.96333L14.5347 1.96485Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
      />
    </SvgIcon>
  );
};
export const PencilIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M17.4999 17.4999H10.8333M2.08325 17.9166L6.70764 16.138C7.00343 16.0242 7.15132 15.9673 7.28968 15.8931C7.41259 15.8271 7.52975 15.751 7.63995 15.6654C7.76402 15.5692 7.87606 15.4571 8.10015 15.233L17.4999 5.83326C18.4204 4.91279 18.4204 3.4204 17.4999 2.49993C16.5795 1.57945 15.0871 1.57945 14.1666 2.49992L4.76682 11.8997C4.54273 12.1238 4.43069 12.2358 4.33441 12.3599C4.2489 12.4701 4.17275 12.5873 4.10678 12.7102C4.03251 12.8485 3.97563 12.9964 3.86186 13.2922L2.08325 17.9166ZM2.08325 17.9166L3.79835 13.4574C3.92108 13.1383 3.98245 12.9787 4.0877 12.9057C4.17969 12.8418 4.2935 12.8176 4.4035 12.8386C4.52936 12.8627 4.65024 12.9836 4.89199 13.2253L6.77456 15.1079C7.01631 15.3496 7.13719 15.4705 7.16122 15.5964C7.18223 15.7064 7.15807 15.8202 7.09421 15.9122C7.02112 16.0174 6.86158 16.0788 6.54248 16.2015L2.08325 17.9166Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const SearchIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="18" height="19" viewBox="0 0 18 19" fill="none">
      <path
        d="M15.75 16.25L13.1251 13.625M15 9.125C15 12.6458 12.1458 15.5 8.625 15.5C5.10418 15.5 2.25 12.6458 2.25 9.125C2.25 5.60418 5.10418 2.75 8.625 2.75C12.1458 2.75 15 5.60418 15 9.125Z"
        stroke="#A0A0A0"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ActiveIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 8 8" fill="none">
      <circle cx="4" cy="4" r="4" fill="#12B76A" />
    </SvgIcon>
  );
};
